import { BOOK_CONSULTATION_URL } from "@/lib/brand";
import { ArrowRight } from "lucide-react";
import ShareByEmail from "./ShareByEmail";

/**
 * Bottom action row for a calculator: Share-via-Email button (all 9 calcs)
 * and optionally the "Talk to Us to Build a Fund Strategy for You" CTA
 * (the 6 investment/growth calcs pass `withStrategyCta`).
 */
export default function CalculatorActions({ testIdPrefix, buildPayload, withStrategyCta = false }) {
  return (
    <div className="mt-10 flex flex-wrap justify-center gap-3">
      <ShareByEmail testIdPrefix={testIdPrefix} buildPayload={buildPayload} />
      {withStrategyCta && (
        <a
          href={BOOK_CONSULTATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-brass"
          data-testid={`${testIdPrefix}-cta`}
        >
          Talk to Us to Build a Fund Strategy for You <ArrowRight size={16} />
        </a>
      )}
    </div>
  );
}
